module.exports = __webpack_public_path__ + "img/sync-gray.b5a32921.svg";